import { useEffect } from "react";

interface PageMeta {
  title: string;
  description?: string;
}

const BASE_TITLE = "Margin Metrics";

export function usePageMeta({ title, description }: PageMeta) {
  useEffect(() => {
    const fullTitle = title === "Dashboard"
      ? `${BASE_TITLE} — Trading Analytics Platform`
      : `${title} | ${BASE_TITLE}`;

    document.title = fullTitle;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && description) {
      metaDesc.setAttribute("content", description);
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", fullTitle);

    const twTitle = document.querySelector('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute("content", fullTitle);

    if (description) {
      const ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.setAttribute("content", description);
      const twDesc = document.querySelector('meta[name="twitter:description"]');
      if (twDesc) twDesc.setAttribute("content", description);
    }
  }, [title, description]);
}
